import React, { useState } from "react";
import "./Page.css";
import CardWrap from "./components/CardWrap";
import { FORM_INITIAL_DATA, FORM_STEP } from "./Constants";

const PublicOnboardingExistingPage = () => {
  const [stepState, setStepState] = useState(FORM_STEP[1]);

  const [formData, setFormData] = useState(FORM_INITIAL_DATA);

  const [warningMessage, setWarningMessage] = useState("");

  const { Component } = stepState;

  const nextPage = () => {
    setStepState(FORM_STEP[stepState.step + 1]);
  };

  const previousPage = () => {
    setStepState(FORM_STEP[stepState.step - 1]);
  };

  return (
    <div className="public-onboarding-existing__root">
      <CardWrap
        step={stepState.step}
        subtitle={stepState.subtitle}
        progress={stepState.step * 20}
      >
        <Component
          formData={formData}
          stepState={stepState}
          previousPage={previousPage}
          nextPage={(newData) => {
            setFormData((x) => ({ ...x, ...newData }));
            nextPage();
          }}
          warningMessage={warningMessage}
          resetData={(msg) => {
            setFormData(FORM_INITIAL_DATA);
            setWarningMessage(msg);
            nextPage();
          }}
        />
      </CardWrap>
    </div>
  );
};

export default PublicOnboardingExistingPage;
